/* assets/byld-sticky-header.js */
(function () {
  'use strict';

  var HIDDEN_CLASS = 'byld-sticky--hidden';
  var ignoreScroll = false;
  var ignoreTimer  = null;

  /* Inject the one rule we need */
  var style = document.createElement('style');
  style.textContent =
    '#header-group:has(#header-component[sticky]).' + HIDDEN_CLASS +
    ' { display: none !important; }';
  document.head.appendChild(style);

  function getHeaderGroup() {
    return document.getElementById('header-group');
  }

  /* Hide on secondary-menu link click */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.secondary-menu .menu-list__link');
    if (!link) return;

    var hg = getHeaderGroup();
    if (hg) hg.classList.add(HIDDEN_CLASS);

    /* Block scroll listener for 1.5s so smooth-scroll doesn't undo us */
    ignoreScroll = true;
    clearTimeout(ignoreTimer);
    ignoreTimer = setTimeout(function () {
      ignoreScroll = false;
    }, 1500);
  });

  /* Restore on intentional user scroll (not the auto-scroll from click) */
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ignoreScroll) return;
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var hg = getHeaderGroup();
      if (hg) hg.classList.remove(HIDDEN_CLASS);
      ticking = false;
    });
  }, { passive: true });

})();